export const devConstants = {
    SUI_CLOCK_OBJECT_ID: "0x6",
    SUI_SYSTEM_STATE_ID: "0x5",
    // AlphaFi constants
    ALPHAFI_LATEST_ORACLE_PACKAGE_ID: "0x879393334080e5413a2f35553d45e3495fd328b1558b1f794d3acb655fa1f752",
    ALPHAFI_FIRST_ORACLE_PACKAGE_ID: "0x1e61b87eb037e18980aff9e9d9f64ef9b5944404b9ecac282630e01af6c2f8f1",
    ALPHAFI_ORACLE_OBJECT_ID: "0xd248eeaa6575d564d5cde3ce743bad27523d807c04db7918bf22db133889d42a",
    ALPHAFI_ORACLE_ADMIN_CAP_ID: "0x00d8933cea5c14f5880041c0ff9c1087d1f73a5e3cbcf01754faa33e8698365b",
    ALPHAFI_LATEST_STDLIB_PACKAGE_ID: "0xcdd17db56599b54352a039ece4f8f63d6dc1450924a6c92b2e360385a1373926",
    ALPHAFI_FIRST_STDLIB_PACKAGE_ID: "0xcdd17db56599b54352a039ece4f8f63d6dc1450924a6c92b2e360385a1373926",
    // AlphaLend constants
    ALPHALEND_LATEST_PACKAGE_ID: "0x4d48971edf46cb13ce3709721ff9fb907a9c27b96b53220738dea9ee9262c824",
    ALPHALEND_FIRST_PACKAGE_ID: "0xf4d973212e8c03488e30837d75ae9374feead9b8d0c168f587b4f8e2f4c2641a",
    LENDING_PROTOCOL_ID: "0x8577bb7f4450e0d342f870b74e3a94922c991a344ad2c539985bdd94a7dca130",
    LENDING_PROTOCOL_CAP_ID: "0xcc3b0e3a8842b8a68c0c55467da0f420a73dc968e6a8849e2e355cc8f14be546",
    LENDING_PROTOCOL_ADMIN_CAP_ID: "0x832ffa50b2da750828a40a3df04bd130a39442dd33626ded20f79d3fca9c9fd6",
    POSITION_CAP_TYPE: "0xf4d973212e8c03488e30837d75ae9374feead9b8d0c168f587b4f8e2f4c2641a::position::PositionCap",
    POSITION_TABLE_ID: "0x3c2014a7428874a8d9b25fd54550d8926f5fcb71fe5a206b7a0ec970b4130264",
    MARKETS_TABLE_ID: "0x4002bda4327e50715a4b1a2e9789156b31f4f30db33dcf3cb627b3a674366f0d",
    ACTIVE_MARKETS: [1, 3], // to-do: think of a way to store this outside sdk(db or seperate contract)
    // Pyth Constants
    PYTH_PACKAGE_ID: "0xabf837e98c26087cba0883c0a7a28326b1fa3c5e1e2c5abdb486f9e8f594c837",
    PYTH_STATE_ID: "0x243759059f4c3111179da5878c12f68d612c21a8d54d85edc86164bb18be1c7c",
    WORMHOLE_PACKAGE_ID: "0xf47329f4344f3bf0f8e436e2f7b485466cff300f12a166563995d3888c296a94",
    WORMHOLE_STATE_ID: "0x31358d198147da50db32eda2562951d53973a0c0ad5ed738e9b17d88b213d790",
    PYTH_PRICE_INDENTIFIER_TYPE: "0xabf837e98c26087cba0883c0a7a28326b1fa3c5e1e2c5abdb486f9e8f594c837::price_identifier::PriceIdentifier",
    PYTH_MAINNET_API_ENDPOINT: "https://hermes-beta.pyth.network",
    PYTH_PRICE_PATH: "/api/latest_price_feeds",
    // Coin Types
    SUI_COIN_TYPE: "0x2::sui::SUI",
    USDT_COIN_TYPE: "0xc060006111016b8a020ad5b33834984a437aaa7d3c74c18e09a95d48aceab08c::coin::COIN",
    USDC_COIN_TYPE: "0xa1ec7fc00a6f40db9693ad1415d0c193ad3906494428cf252621037bd7117e29::usdc::USDC",
    WUSDC_COIN_TYPE: "0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf::coin::COIN",
    VSUI_COIN_TYPE: "0x549e8b69270defbfafd4f94e17ec44cdbdd99820b33bda2278dea3b9a32d3f55::cert::CERT",
    STSUI_COIN_TYPE: "0xd1b72982e40348d069bb1ff701e634c117bb5f741f44dff91e472d3b01461e55::stsui::STSUI",
    ALPHA_COIN_TYPE: "",
    SUI_COIN_TYPE_LONG: "0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI",
};
//# sourceMappingURL=devConstants.js.map